import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Sergio Lazaro Mondargo', // e.g: 'Name | Developer'
  lang: 'es', // e.g: en, es, fr, jp
  description: 'Welcome to my website', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: 'Sergio',
  subtitle: '',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraph: [
    `Mi nombre es Sergio Lázaro soy desarrollador web y marketer.`,
    `Diseñó y desarrollado aplicaciones web durante casi media década. Mi carrera comenzó como desarrollador web para proyectos dentro de la universidad, donde aprendí los entresijos de trabajar solo y con equipos en un ambiente profesional.`,
    `Más tarde creé Binder, una startup reduce el tiempo de impresion mejorando la experiencia de usuario donde nuestro modelo fue patentato el año 2019.`,
    `Llevo trabajando como autonomo para la Clinica Ortega en la ciudad de Huancayo ,donde administro las redes sociales asi como las campañas publicitarias.A menudo contribuyendo como user experience designer.`,
    `Actualmente soy CEO de Medimarketing ,startup de soluciones de tecnologicas enfocadas a la gestion de usuarios y generacion de leads para medicos.`,
    `Asi como fundador de TCEOS agencia de growth marketing enfocado en el desarrollo de sofware para terceros.`,
  ],
  resume: 'https://www.resumemaker.online/es.php', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'project.jpg',
    title: '',
    info: '',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: '',
    info: '',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: '',
    info: '',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: `Si parezco una persona que puede ayudarlo de alguna manera, no dude en ponerse en contacto.`,
  btn: '',
  email: 'sergiolazaromondargo@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'medium',
      url: 'https://medium.com/@sergiolm17',
    },
    {
      id: nanoid(),
      name: 'facebook',
      url: 'https://www.facebook.com/sergiolm17/',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/sergio-manuel-lazaro-mondargo/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/Sergiolm17',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
